import {AbstractConditionDescriptionComponent} from "../AbstractConditionDescriptionComponent";

export class ConditionItemRateDate extends AbstractConditionDescriptionComponent {
    static instance = () => AbstractConditionDescriptionComponent.instance(ConditionItemRateDate, require('./conditionItemRateDate.html'));
}